<template>
  <div class="page-not-found">
    <div class="content">
      <span class="code">404</span>
      <span class="message">{{ $route.meta.label }}</span>
      <div class="actions">
        <p-vue-button class="p-button p-button-info p-button-rounded p-jc-center"
                      
                      @click="$router.go(-1)">
          <i-icon name="arrow" class="back" />
        </p-vue-button>
        <p-vue-button class="p-button p-button-accent p-button-rounded p-jc-center"
                      
                      @click="$router.push({ name: 'Dashboard' })">
          {{ __("Home") }}
        </p-vue-button>
      </div>
    </div>
  </div>
</template>

<style scoped>

  .page-not-found {
    display: flex;
    align-items: center;
    justify-content: center;

    min-height: 100vh;

    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;
    background-image: url('../assets/img/banners/auth-bg.png');
  }

  .content {
    display: flex;
    flex-direction: column;

    text-align: center;
  }

  .actions {
    gap: 2px;
    display: grid;
    grid-template-columns: 60px 1fr;

    margin-top: 15px;
  }

  .page-not-found .code {
    font-size: 50px;
  }

  .page-not-found .message {
    font-size: 30px;
  }

  .back {
    width: 20px;
    height: 20px;

    transform: rotate(-90deg);
  }

  .actions .p-button:first-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .actions .p-button:last-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

</style>